
export {} from '../../frontend-js-clay-web/__liferay__/exports/@clayui$label.js';
import __x__ from '../../frontend-js-clay-web/__liferay__/exports/@clayui$label.js';export default __x__;